import { type Path } from 'react-router'
import { type LinkProps } from 'react-router-dom'

import { cleanJoin } from 'utils/strings'

export enum RunStatusDetailsAnchor {
  DIAGNOSIS = '#diagnosis'
}

export interface RunStatusLinkTo extends Path {
  hash: RunStatusDetailsAnchor
}

export interface RunStatusLinkProps extends LinkProps {
  to: Partial<RunStatusLinkTo>
}

interface GetHistoryRunUrlParams {
  dependencyId?: string | null
  failureFlagName?: string | null
  serviceId: string
  testId: string
}

interface GetStatusRunUrlParams extends GetHistoryRunUrlParams {
  runNumber?: number
  teamId?: string
}

export function getHistoryRunUrl({
  dependencyId,
  failureFlagName,
  serviceId,
  testId
}: GetHistoryRunUrlParams) {
  const baseRoute = `/services/${serviceId}/history/${testId}`

  if (dependencyId) return `${baseRoute}/${dependencyId}`
  if (failureFlagName) return `${baseRoute}/failure-flag/${failureFlagName}`

  return `${baseRoute}`
}

/**
 * A service test is run on A) the service itself or B) a dependency of that service.
 * If `dependencyId` is included, the url will include it (B). Otherwise, it goes to (A).
 */
export function getStatusRunUrl({
  dependencyId,
  failureFlagName,
  runNumber,
  serviceId,
  teamId,
  testId
}: GetStatusRunUrlParams) {
  const baseSegment = `/services/${serviceId}/status/${testId}`
  const typeSegment =
    dependencyId ??
    (failureFlagName ? `failure-flag/${failureFlagName}` : undefined)
  const runSegment = runNumber ? `run/${runNumber}` : undefined
  const teamParam = teamId ? `?teamId=${teamId}` : ''

  return `${cleanJoin([baseSegment, typeSegment, runSegment], '/')}${teamParam}`
}
